export const listPath = [
    {
        name: 'Главная',
        path: '/',
    },
    {
        name: 'Кейсы',
        path: '/cases',
    },
    {
        name: 'Разработка',
        path: '/cases/development',
    },
];

export const listTitle = [
    {
        title: 'Сервис для обманутых дольщиков на&nbsp;Госуслугах',
        subtitle: 'Интегрировали сервис для облегчения получения компенсаций на&nbsp;госпортал.',
        description: [
            {
                name: 'сроки проекта',
                details: 'март 2023&nbsp;&mdash; июнь 2023',
            },
            {
                name: 'Отрасль',
                details: 'Строительство и&nbsp;ЖКХ',
            },
            {
                name: 'Услуги',
                details: 'Разработка новых сервисов и&nbsp;техническая поддержка платформы',
            },
        ],
        company: 'Фонд развития территорий',
        companyLink: 'https://xn--p1aee.xn--p1ai/',
        companyLinkName: 'фрт.рф',
        text: 'Фонд развития территорий&nbsp;&mdash; создан на&nbsp;базе Фонда защиты прав дольщиков и&nbsp;Фонда содействия реформированию ЖКХ и&nbsp;объединяет земельные, финансовые и&nbsp;организационные ресурсы для защиты прав и&nbsp;законных интересов дольщиков, модернизации ЖКХ и&nbsp;комплексного развития территорий.',
    },
];

export const listTarget = [
    {
        name: 'Цель',
        description:
            'До&nbsp;конца 2023&nbsp;г. около 80&nbsp;тысяч семей должны получить компенсации или квартиры от&nbsp;Фонда, поэтому для максимального ускорения этого процесса было принято решение вывести этот сервис на&nbsp;портал Госуслуг.',
    },
];

export const descriptionBlock = {
    title: 'Описание проекта',
    leftText: `
        <p>Партнерство с&nbsp;Фондом развития территорий началось в&nbsp;2019 году с&nbsp;развития сайта для Фонда ЖКХ, предшественника ФРТ. Потом была ответственная работа по&nbsp;миграции данных из&nbsp;одной системы в&nbsp;другую в&nbsp;период объединения.</p>
        <p>В&nbsp;начале 2023 года наша команда закончила один из&nbsp;этапов технического обновления сайта фрт.рф. Об&nbsp;этом проекте <a href="https://webpractik.ru/cases/development/fondrt" target="_blank" rel="noopener norefferer">рассказывали в&nbsp;кейсе</a>.</p>`,
    pic: '/images/pic/frtService/desc.jpg',
    picAlt: 'Логотип Фрт',
};

export const listProcess = [
    {
        title: 'Задачи',
        list: [
            {
                number: '1.',
                text: 'Проанализировать имеющиеся регламенты и&nbsp;техническую документацию.',
            },
            {
                number: '2.',
                text: 'Разработать дорожную карту проекта.',
            },
            {
                number: '3.',
                text: 'Составить подробное техническое задание для разработчиков.',
            },
            {
                number: '4.',
                text: 'Спроектировать архитектуру интеграции сервиса.',
            },
            {
                number: '5.',
                text: 'Реализовать интеграцию с системами и настроить взаимодействие.',
            },
            {
                number: '6.',
                text: 'Провести тестирование.',
            },
            {
                number: '7. ',
                text: 'Подготовить проект для сертификации в&nbsp;правительственной комиссии.',
            },
            {
                number: '8. ',
                text: 'Запустить сервис.',
            },
        ],
    },
];

export const implementationBlock = {
    title: 'Реализация проекта',
    leftText: `
        <p>К&nbsp&nbsp;работе приступили в&nbsp;марте 2023&nbsp;г. Подготовительный этап длился 3&nbsp;недели. За&nbsp;это время важно было изучить всю 
        документацию, составить и&nbsp;согласовать план проекта со&nbsp;всеми сторонами. </p>
        <p>Аналитики и&nbsp;техлид начали работу над проектом с&nbsp;изучения многостраничных технических регламентов. Потом составили подробное техническое задание и&nbsp;поэтапно спроектировали архитектуру многоступенчатой интеграции. 
        В&nbsp;этом процессе помог опыт команды по&nbsp;взаимодействию с&nbsp;ЕСИА.</p>
        <p>Все эти работы на&nbsp;подготовительном этапе помогли разработчикам настроить корректное 
        взаимодействие нескольких систем и&nbsp;значительно сократить время на&nbsp;техническую реализацию проекта.</p>`,
    rightText:
        'Проект изначально имел несколько ограничений: жесткие техтребования и&nbsp;сильно сжатые сроки.',
};

export const implementationBlock2 = {
    leftText: `
        <p>Непосредственно техническая реализация заняла 9&nbsp;недель, и&nbsp;в&nbsp;этот период было несколько тестовых 
        демонстраций предварительных результатов.</p>
        <p>Информационные системы ведомств не&nbsp;могут напрямую общаться с&nbsp;порталом Госуслуг. Это сделано для обеспечения безопасности. 
        Обмен данными происходит через систему межведомственного электронного взаимодействия (СМЭВ). Это универсальная среда взаимодействия 
        с&nbsp;определенными стандартами и&nbsp;по&nbsp;унифицированному протоколу общения.</p>`,
    rightText: 'Интеграция была последовательная и&nbsp;делалась через посредника.',
};

export const textBlock = {
    leftText: `
        <p>Эту систему нельзя обойти или исключить из&nbsp;решения задачи интеграции с&nbsp;Госуслугами, 
        так как это связующее звено между порталом и&nbsp;ведомством, у&nbsp;которого запрашивается услуга. </p>
        <p>Процесс взаимодействия выглядит так. Запрос на&nbsp;сайте Госуслуги (в&nbsp;нашем случае&nbsp;&mdash; 
        заявление на&nbsp;восстановление прав дольщика) передаётся в&nbsp;Фонд развития территорий через СМЭВ, 
        и&nbsp;система передаёт ответ от&nbsp;ведомства заказчику услуги. Работа через СМЭВ происходит по&nbsp;протоколу SOAP.</p>
    `,
};

export const imageBlock = {
    image: '/images/svg/frtService/scheme.svg',
};

export const textBlock2 = {
    leftText: `
        <p>Для интеграции сервиса для обманутых дольщиков мы&nbsp;реализовали работы в&nbsp;конструкторе услуги 
        и&nbsp;помогали интегрировать публичную часть конструктора, разработанную другим партнером ФРТ.</p>
        <p>Далее создали VM-шаблоны, по&nbsp;которым данные из&nbsp;конструктора обрабатываются для передачи в&nbsp;СМЭВ. 
        Для проверки корректности поступающих данных, СМЭВ использует разработанную нами ХSD-схему.</p>
    `,
};

export const quoteBlock = {
    text:
        '«Этот проект важен и интересен не только, как новый опыт, но и как возможность внести свой вклад в решение социально значимого вопроса. ' +
        'И в этом наши приоритеты с ФРТ совпадают. Каждую неделю мы проводили встречи и показывали результаты. Координаторы проекта со стороны ФРТ' +
        ' были максимально вовлечены в процесс и помогали выстраивать коммуникации с федеральным министерством по трактовке технических регламентов, ' +
        'чтобы интеграция проходила максимально быстро и четко. Также в процессе работы пришлось взаимодействовать с другими ИТ-партнерами Фонда, ' +
        'что накладывало определенные технические ограничения».',
    photo: '/images/pic/frtService/photo.jpg',
    alt: 'Фото Александра Букурова',
    name: 'Александр Букуров',
    job: 'генеральный директор &laquo;Вебпрактик&raquo;',
};

export const textBlock3 = {
    leftText:
        'Следующий важный этап&nbsp;&mdash; это проверка работоспособности сервиса и&nbsp;его сертификация комиссией Минцифры, ' +
        'которая заняла еще 2&nbsp;недели. После тестирования и&nbsp;точечных доработок сервис получил необходимые допуски ' +
        'и&nbsp;технические сертификаты соответствия и&nbsp;успешно интегрирован в&nbsp;продуктовую среду. Релиз состоялся в&nbsp;июне 2023&nbsp;г.',
    rightText:
        'Сервис получил сертификаты Минцифры и&nbsp;успешно интегрирован в&nbsp;продуктовую среду.',
};

export const resultBlock = {
    title: 'Результаты',
    leftText:
        'За&nbsp;3&nbsp;месяца сделали MVP проекта, ввели его в&nbsp;продуктовую среду и&nbsp;занимаемся разработкой второй версии услуги. ' +
        'Команда выдержала все сроки и&nbsp;продолжает работы по&nbsp;расширению функционала и&nbsp;технической поддержке ' +
        'этого важного и&nbsp;динамичного проекта. ',
};

export const resultBlock2 = {
    leftText:
        'Теперь обманутые участники, которым Фонд развития территорий назначил выплату компенсаций, могут оформить их&nbsp;на&nbsp;портале ' +
        'Госуслуг. Для этого надо будет выбрать сервис &laquo;Предоставление компенсационные выплаты гражданам&nbsp;&mdash; ' +
        'участникам долевого строительства&raquo; и&nbsp;подать заявление, которое будет рассмотрено в&nbsp;срок до&nbsp;10&nbsp;дней. ' +
        'Отслеживать информацию о&nbsp;ходе дела можно с&nbsp;помощью push-уведомлений.',
    rightText: `
        <p>Заявления будут рассматриваться</p>
        <p class="bold-text">в срок до <span class="bold-text bold-text--big">10</span> дней</p>
    `,
};

export const developmentBlock = {
    title: 'Развитие проекта',
    leftText: `
        <p>Параллельно с&nbsp;интеграцией на&nbsp;портал Госуслуг команда &laquo;Вебпрактик&raquo; работала и&nbsp;по&nbsp;другим направлениям проекта. 
        За&nbsp;8&nbsp;месяцев сотрудничества с&nbsp;ФРТ реализовали более 300&nbsp;задач, среди которых интеграция с&nbsp;ЕСИА, 
        цифровое объединение с&nbsp;Фондом ЖКХ, полная переработка Личного кабинета, добавление новых услуг, перевод Личного кабинета 
        на&nbsp;новых технологический стек, реализация специального блока услуг для жителей новых территорий. </p>
        <p>Достройка проблемных объектов и&nbsp;восстановление прав дольщиков&nbsp;&mdash; одна из&nbsp;приоритетных национальных целей 
        развития страны до&nbsp;2024&nbsp;года. Команда &laquo;Вебпрактик&raquo; внесла свой вклад в&nbsp;решение этих задач, 
        разработав быстрые и&nbsp;современные ИТ-решения для цифровой трансформации госсервисов.</p>
    `,
};

export const listTeam = [
    {
        title: 'Команда',
        members: [
            {
                name: 'Татьяна Антипова',
                position: 'Менеджер проекта',
            },
            {
                name: 'Сергей Волошин',
                position: 'Backend-техлид',
            },
            {
                name: '1 бизнес-аналитик',
            },
            {
                name: '1 бэкенд-разработчик',
            },
            {
                name: '1 QA-инженер',
            },
            {
                name: '1 DevOps-инженер',
            },
        ],
    },
];

export const reviewBlock = {
    text: 'Вебпрактик&quot; успешно создали новую версию сайта &laquo;Почта Банк&raquo;. Был обновлен дизайн и&nbsp;разработана современная программная платформа, обеспечивающая интеграцию с&nbsp;внутрибанковскими и&nbsp;внешними системами.',
    author: 'Павел Куданкин',
    position: 'Руководитель направления веб-проектов, Почта Банк',
    logo: '/images/svg/frtService/logo.svg',
};

export const iconsBlock = [
    {
        title: 'сделали MVP с&nbsp;уникальной интеграцией за&nbsp;3&nbsp;месяца',
        icon: '/images/svg/common/icon1.svg',
    },
    {
        title: 'составили комплект документов по&nbsp;реализованной интеграции',
        icon: '/images/svg/common/docs.svg',
    },
    {
        title: 'настроили взаимодействие информационной системы заказчика с&nbsp;порталом Госуслуг через СМЭВ',
        icon: '/images/svg/common/cloud.svg',
    },
    {
        title: 'разработали VM-шаблоны для взаимодействия с&nbsp;визуальным конструктором',
        icon: '/images/svg/common/icon2.svg',
    },
];

export const nextProjectFrt = {
    nextProjectTitle: 'Почта Банк',
    nextProjectImg: '/images/pic/frtService/pochtabank.jpg',
    nextProjectLink: '/cases/development/pochtabank/',
    nextProjectLinkTitle: 'Новая версия сайта Почта Банка',
    nextProjectText:
        'Перенесли сайт на&nbsp;новую платформу с&nbsp;облачной архитектурой и&nbsp;создали конструктор для управления контентом',
};
